import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy as BaseTitleStrategy, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TitleStrategy extends BaseTitleStrategy {
  private readonly title = inject(Title);

  readonly leader: string = 'Paystashio';
  readonly separator: string = ' | ';

  override updateTitle(routerState: RouterStateSnapshot) {
    const routeTitle = this.buildTitle(routerState);
    const root = routerState.root.firstChild;
    const case1 = root?.title != undefined;
    const case2 = routeTitle !== undefined && routeTitle !== root?.title;
    let title = this.leader;
    if (case1) title += this.separator + root.title;
    if (case2) title += this.separator + routeTitle;
    this.title.setTitle(title);
  }
}
